<bringoz-icon [iconName]="icon" class="gray-102"
              [ngbTooltip]="batteryLevelTooltip" openDelay="300" triggers="hover" container="body"></bringoz-icon>


<ng-template #batteryLevelTooltip class="flex layout-column">
  <span> {{((batteryLevel > 0 ? batteryLevel : 0) * 100) | number:'1.0-0'}}%</span>
</ng-template>
